import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const nbaNewsHeaders = {
  "X-BingApis-SDK": "true",
  "X-RapidAPI-Key": "daa86867d7mshd4fa9f0eb9b84e4p1eff51jsne5f5201ab6e7",
  "X-RapidAPI-Host": "bing-news-search1.p.rapidapi.com",
};

const baseUrl = "https://bing-news-search1.p.rapidapi.com";

const createRequest = (url) => ({ url, headers: nbaNewsHeaders });

export const nbaNewsApi = createApi({
  reducerPath: "nbaNewsApi",
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getNbaNews: builder.query({
      query: ({ category, count }) =>
        createRequest(
          `/news/search?q=${category}&safeSearch=Off&textFormat=Raw&freshness=Day&count=${count}`
        ),
    }),
  }),
});

export const { useGetNbaNewsQuery } = nbaNewsApi;
